import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


const routes: Routes = [
  {
    path: 'tourism',
    loadChildren: () =>
      import('./app-modules/tourism-module/tourism.module').then((m) => m.TourismModule),
  },
  {
    path: 'banking',
    loadChildren: () =>
      import('./app-modules/banking-module/banking.module').then(
        (m) => m.BankingModule
      ),
  },
  {
    path: 'ministry',
    loadChildren: () =>
      import('./app-modules/ministry-module/ministry.module').then(
        (m) => m.MinistryModule
      ),
  },
  {
    path: 'interior',
    loadChildren: () =>
      import('./app-modules/interior-module/interior.module').then(
        (m) => m.InteriorModule
      ),
  },{
    path: 'cabinet',
    loadChildren: () =>
      import('./app-modules/cabinet-module/cabinet.module').then(
        (m) => m.CabinetModule
      ),
  },{
    path: 'moh',
    loadChildren: () =>
      import('./app-modules/moh-module/moh.module').then(
        (m) => m.MohModule
      ),
  },{
    path: 'ifta',
    loadChildren: () =>
      import('./app-modules/dar-alifta-module/dar-alifta.module').then(
        (m) => m.DarAliftaModule
      ),
  },{
    path: 'cbe',
    loadChildren: () =>
      import('./app-modules/cbe-module/cbe.module').then(
        (m) => m.CbeModule
      ),
  },
  {
    path: 'etaa',
    loadChildren: () =>
      import('./app-modules/etta-module/etta.module').then(
        (m) => m.EttaModule
      ),
  },
  {
    path: 'saudi-agent',
    loadChildren: () =>
      import('./app-modules/saudi-agent-module/saudi-agent.module').then(
        (m) => m.SaudiAgentModule
      ),
  },
  {
    path: 'tax-agency',
    loadChildren: () =>
      import('./app-modules/tax-agency-module/tax-agency.module').then(
        (m) => m.TaxAgencyModule
      ),
  },
  {
    path: 'foreign-affairs',
    loadChildren: () =>
      import('./app-modules/foreign-affairs-module/foreign-affairs.module').then(
        (m) => m.ForeignAffairsModule
      ),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./app-modules/auth-module/auth.module').then(
        (m) => m.AuthModule
      ),
  },
  {
    path: 'transporters',
    loadChildren: () =>
      import('./app-modules/transporters-module/transporters.module').then(
        (m) => m.TransportersModule
      ),
  },
  {
    path: 'tourism-companies',
    loadChildren: () =>
      import('./app-modules/tourism-companies-module/tourism-companies.module').then(
        (m) => m.TourismCompaniesModule)
  },
  {
    path: 'consulate',
    loadChildren: () =>
      import('./app-modules/consulate-module/consulate.module').then(
        (m) => m.ConsulateModule
      ),
  },
  {
    path: 'hotels',
    loadChildren: () =>
      import('./app-modules/hotels-module/hotels.module').then(
        (m) => m.HotelsModule
      ),
  },
  {
    path: 'hotelgate',
    loadChildren: () =>
      import('./app-modules/hotel-gate-module/hotel-gate.module').then(
        (m) => m.HotelGateModule
      ),
  }, 
  {
    path: 'statistics',
    loadChildren: () =>
      import('./app-modules/statistics-module/statistics.module').then((m) => m.StatisticsModule),
  },

  

  //AuthComponent
  // to try redirect 
  // {
  //   path: '',
  //   redirectTo: 'banking/login',
  //   pathMatch: 'full',
  // }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
